import { Help as HelpIcon, Search as SearchIcon } from '@mui/icons-material';
import { AppBar, Box, IconButton, Toolbar } from '@mui/material';
import { useFeatureFlags } from 'apps/wrapper/src/hooks/feature-flags/use-feature-flags';
import { useLocations } from 'apps/wrapper/src/hooks/use-locations';
import { useState } from 'react';
import { ReactComponent as RwLogo } from '../../../../assets/logo-small.svg';
import config from '../../../../config/config.json';
import { useEventBus } from '../../../../hooks/use-event-bus/use-event-bus';
import AlertButton from './alert-button';
import InboxButton from './inbox-button';
import { LocationSelection } from './location-selection/location-selection';
import { SearchBar } from './search-bar/search-bar';
import SettingsButton from './settings-button';
import UserButton from './user-button';

export const TopNavTablet = () => {
  const { publish } = useEventBus();
  const { selectedLocation } = useLocations();
  const { hasFeature } = useFeatureFlags();
  const hasUniversalSearch = hasFeature(selectedLocation?.id!, 'UniversalSearch');
  const hasAlerts = hasFeature(selectedLocation?.id!, 'Alerts2');
  const hasUnifiedInbox = hasFeature(selectedLocation?.id!, 'UnifiedInbox');
  const [isSearchOpen, setIsSearchOpen] = useState(false);

  const actionMenuStyles = {
    color: '#80979F',
    width: 48,
    height: 48,
    margin: '11px 0 11px 0px',
    borderRadius: 12,
    '&:hover': {
      backgroundColor: '#265D7C'
    },
    '&:focus-visible': {
      border: '2px solid #1EB9FB'
    }
  };

  return (
    <AppBar position="relative" sx={{ backgroundColor: 'nav.main' }}>
      <Toolbar sx={{ justifyContent: 'space-between' }}>
        <Box>
          <RwLogo />
        </Box>
        <LocationSelection />
        <Box display="flex" alignItems="center">
          {hasUniversalSearch && (
            <IconButton onClick={() => setIsSearchOpen(true)} sx={actionMenuStyles}>
              <SearchIcon />
            </IconButton>
          )}
          {hasUnifiedInbox && <InboxButton />}
          {hasAlerts && (
            <>
              <AlertButton />
              <Box sx={{ width: '2px', height: '48px', backgroundColor: 'nav.dark' }} />
            </>
          )}
          <SettingsButton />
          <IconButton
            sx={{ ...actionMenuStyles }}
            onClick={() => {
              publish({
                messageType: 'navigate',
                data: {
                  pathname: config.support.url,
                  crossFrame: true,
                  replaceState: false
                }
              });
            }}
          >
            <HelpIcon />
          </IconButton>
          <UserButton />
        </Box>
      </Toolbar>
      <SearchBar visible={isSearchOpen} onClose={() => setIsSearchOpen(false)} />
    </AppBar>
  );
};
